import { MappedFacetListItem, FacetListDTO } from "./filters.type";
import { mapFacetList } from "./mapFacetList";
import getEnvironment from "../getEnvironment";

const getFacetList = async (
  url: string,
  authToken: string,
  isToUseAuthZero: boolean
): Promise<MappedFacetListItem[] | any> => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (getEnvironment() === "localhost") {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  const res = await fetch(url, {
    method: "GET",
    headers,
  });

  if (!res.ok) {
    throw new Error(
      `An error (${res.status}) occurred while fetching the data.`
    );
  }

  const result: FacetListDTO = await res.json();

  if (result.degradedServices?.length > 0) {
    return { degradedServices: result.degradedServices };
  }

  return mapFacetList(result);
};

export default getFacetList;
